import {
  Component,
  OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'pro',
  styleUrls: ['./pro.scss'],
  templateUrl: './pro.component.pug'
})
export class ProComponent implements OnInit {

  public localState: any;
  public features: Feature[];
  constructor(
    public route: ActivatedRoute,
    private http: HttpClient
  ) {
    function compare(a, b) {
      if (a.availability < b.availability) {
        return -1;
      }
      if (a.availability > b.availability) {
        return 1;
      }
      return 0;
    }
    this.features = [
      {
        name: 'Configurable hotkeys',
        url: '',
        availability: 0
      },
      {
        name: 'Cache store on HDD',
        url: '',
        availability: 0
      },
      {
        name: 'Operate with several GPS devices',
        url: '',
        availability: 0
      },
      {
        name: '.znc support',
        url: '',
        availability: 0
      },
      {
        name: '.znm support',
        url: '',
        availability: 0
      },
      {
        name: 'wpt, plt, gpx import',
        url: '',
        availability: 0
      },
      {
        name: 'Routes',
        url: '',
        availability: 0
      },
      {
        name: 'Track recording',
        url: '',
        availability: 0
      },
      {
        name: 'Garmin support',
        url: '',
        availability: 2
      },
      {
        name: 'Tripmeter',
        url: '',
        availability: 1
      },
      {
        name: 'Max speed alert',
        url: '',
        availability: 2
      },
      {
        name: 'Active point list',
        url: '',
        availability: 0
      },
      {
        name: 'Compass',
        url: '',
        availability: 2
      },
      {
        name: 'Scale line',
        url: '',
        availability: 1
      },
      {
        name: 'Zoom line',
        url: '',
        availability: 1
      },
      {
        name: 'Map preload',
        url: '',
        availability: 1
      },
      {
        name: 'Znm map creation',
        url: '',
        availability: 1
      },
      {
        name: 'Mass wpt edit',
        url: '',
        availability: 1
      },
      {
        name: 'Wpt creator',
        url: '',
        availability: 1
      },
      {
        name: 'Wpt creator: instant creation',
        url: '',
        availability: 2
      },
      {
        name: 'Wpt creator: coord format switch',
        url: '',
        availability: 2
      },
      {
        name: 'Export to GPX',
        url: '',
        availability: 1
      },
      {
        name: 'Sas planet cache scanner',
        url: '',
        availability: 1
      },
      {
        name: 'Route point free reorder',
        url: '',
        availability: 2
      },
      {
        name: 'Route point free insertion',
        url: '',
        availability: 2
      },
      {
        name: 'Measure tool',
        url: '',
        availability: 1
      },
      {
        name: 'Clustering',
        url: '',
        availability: 2
      },
    ];
    this.features = this.features.sort(compare);
  }

  public ngOnInit() {
    this.route
      .data
      .subscribe((data: any) => {
        /**
         * Your resolved data from route.
         */
        this.localState = data.yourData;
      });
    console.log('hello `pro` component');
  }

}

export interface Feature {
  name: string;
  url: string;
  availability: number;
}



// WEBPACK FOOTER //
// ./src/app/pro/pro.component.ts